import { Component, OnInit, Input, ViewChild, Output } from '@angular/core';
import { StoreService } from '../../../_services';
import { IChangeCallback, IStore } from '../../../_entities';
import { PopoverInput } from '../base/popover-input';
import { List } from 'linqts';

import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';

import * as _ from 'lodash';

@Component({
	selector: 'country-own-region-store-tree',
	template: require('./country-own-region-store-tree.component.html')
})
export class CountryOwnRegionStoreTreeComponent extends PopoverInput implements OnInit {

	constructor(/*private storeService: StoreService*/) {
		super();
		//this.stores = this.storeService.getRegionStoreList();
		this.config = TreeviewConfig.create({
			hasAllCheckBox: false,
			hasFilter: true,
			hasCollapseExpand: false,
			decoupleChildFromParent: true,
			maxHeight: 260
		});

	}

	@Input() allStores: Promise<any[]>;
	stores: Promise<any[]>;

	config: TreeviewConfig;

	items: TreeviewItem[];

	ngOnInit() {
		this.init();
	}

	anyChecked(item) {
		return item.children.findIndex(x => x.checked) > -1;
	}

	//event innehåller hela arrayen av valda regioner
	onSelectedChange($event: any) {

		const countries = [];
		const regions = [];
		const stores = [];

		this.items.forEach(country => {

			if (country.checked) {
				countries.push(country.value);
			}

			(country.children || []).forEach(region => {

				if (region.checked && !country.checked) {
					regions.push(region.value);
				}

				region.disabled = country.checked;
				(region.children || []).forEach(store => {

					if (store.checked && !region.checked && !country.checked) {
						stores.push(store.value);
					}

					store.disabled = region.checked || country.checked;
				});
			});
		});

		const state = { countries: countries, regions: regions, stores: stores };


		//this.dirtyValue = state;
		Promise.resolve(null).then(() => this.dirtyValue = state);

	}


	public init(): void {
		this.allStores.then(result => {

			const x = result.map(country => ({
				text: country.name,
				collapsed: !country.regions.some(region => this.originalValue.regions.indexOf(region.id) > -1 || region.stores.some(store => (this.originalValue.stores.indexOf(store.id) > -1))),
				value: country.code,

				children: country.regions.map(region => ({
					text: region.name,
					collapsed: !region.stores.some(store => this.originalValue.stores.indexOf(store.id) > -1),
					value: region.id,

					children: region.stores.map(store => ({
						value: store.id,
						text: store.storeCode + " · " + store.popularName,
						checked: this.originalValue.stores.indexOf(store.id) > -1
					}))

				}))
			}));


			const treeItems = x.map(x => {
				const item = new TreeviewItem(x);
				return item;
			});

			//set checked outside main init loop because of how ngx-treeview works internally with children
			treeItems.forEach(country => {
				country.checked = this.originalValue.countries.indexOf(country.value) > -1;

				(country.children || []).forEach(region => {
					region.checked = this.originalValue.regions.indexOf(region.value) > -1;
				});
			});
		
			this.items = treeItems;

			console.dir(this.items);

		});
	}

	public onShow(): void {
		this.init();
	}

	get hasChanges() {

		if (!this.dirtyValue)
			return false;

		const arraysSame =
			(this.dirtyValue.stores.length === this.originalValue.stores.length) && (this.dirtyValue.stores.length === _.intersection(this.dirtyValue.stores, this.originalValue.stores).length)
			&& (this.dirtyValue.countries.length === this.originalValue.countries.length) && (this.dirtyValue.countries.length === _.intersection(this.dirtyValue.countries, this.originalValue.countries).length)
			&& (this.dirtyValue.regions.length === this.originalValue.regions.length) && (this.dirtyValue.regions.length === _.intersection(this.dirtyValue.regions, this.originalValue.regions).length);

		return !arraysSame;
	}

	get selectedCountries(): TreeviewItem[] {

		if (!!this.items && this.originalValue) {
			return this.items.filter(x => 
				(x.children ||[]).some(y => (y.children || []).some(z =>  this.originalValue.stores.indexOf(z.value) > -1)));
		}

		return null;
	}

	getSelectedStores(item: TreeviewItem): TreeviewItem[] {

		const list = new List(item.children);

		return list.SelectMany(x => new List(x.children).Where(x => this.originalValue.stores.indexOf(x.value) > -1)).ToArray();

	}

	getSelectedStoresList(item: TreeviewItem): string {
		return this.getSelectedStores(item).map(x => x.text).join(", ");
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/country-own-region-store-tree.component.ts